<template lang="">
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:inputValue="this.plant"
					:options="this.plants"
					:onChange="value => changeValue({ name: 'plant', value })"
				/>
			</el-col>
			<el-col :span="6">
				<sf-group-wrapper :label="getMessage_('SWCC000216')">
					<el-date-picker
						v-model="searchDate"
						@change="changeSearchDate"
						type="daterange"
						align="right"
						start-placeholder="Start Date"
						end-placeholder="End Date"
						range-separator="~"
						format="yyyy-MM-dd"
						style="height: 38px"
					/>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('SWCC000217')"
					:inputValue="this.searchUserId"
					:maxlength="10"
					:onChange="value => changeValue({ name: 'searchUserId', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('SWCC000218')"
					:inputValue="this.searchUserNm"
					:maxlength="50"
					:onChange="value => changeValue({ name: 'searchUserNm', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line icon="search" v-if="isButton_(scrId, 'CR')" :onClick="() => searchList()">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>
<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/LoginHistory/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		var date = new Date();
		var month = parseInt(date.getMonth() + 1);
		var day = date.getDate();
		if (month < 10) month = '0' + month;
		if (day < 10) day = '0' + day;
		var currentDate = date.getFullYear() + '-' + month + '-' + day;
		return {
			searchDate: [new Date(currentDate), new Date(currentDate)]
		};
	},
	components: {},
	computed: {
		...serviceComputed,
		...rootComputed
	},
	methods: {
		...serviceMethods,
		async searchList(currentPage = 1, pageUnit = this.groups.pageUnit) {
			this.$sf_toggleLoading(true);

			let searchParams = {
				plantCd: this.plant,
				searchLoginStrDt: this.$moment(this.searchDate[0]).format('YYYYMMDD'),
				searchLoginEndDt: this.$moment(this.searchDate[1]).format('YYYYMMDD'),
				searchUserId: this.searchUserId,
				searchUserNm: this.searchUserNm
			};
			// console.log('searchParams', searchParams);
			// console.log('@@@@ currentPage: ', currentPage);

			// let data = await this.getLoginHistoryList_({ searchParams });

			await this.getLoginHistoryList_({ searchParams, currentPage, pageUnit })
				.then(header => {})
				.catch(e => {
					this.$sf_toast({
						title: 'error',
						type: 'error',
						position: 'bottom-right',
						message: this.getMessage_(e.header.messageCd)
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async getDefaultSelect() {
			await this.getPlants_();
			await this.defaultSelect({ optionNm: 'plants', valueNm: 'plant' });
		},
		getCurrentDate() {
			var date = new Date();
			var month = parseInt(date.getMonth() + 1);
			var day = date.getDate();
			if (month < 10) month = '0' + month;
			if (day < 10) day = '0' + day;
			var currentDate = date.getFullYear() + '-' + month + '-' + day;
			//console.log('getCurrentDate', currentDate);
			//this.selectDate({ currentDate, currentDate });
		},
		changeSearchDate(data) {
			let from = this.$moment(data[0]).format('YYYY-MM-DD');
			let to = this.$moment(data[1]).format('YYYY-MM-DD');
			// console.log('changeSearchDate', from);
			this.selectDate({ from, to });
		},
		async pageLoad() {
			await this.getDefaultSelect();
			//await this.getCurrentDate();
			await this.searchList();
		}
	},
	created() {
		this.pageLoad();
	}
};
</script>
<style>
.flexStyle {
	display: flex;
}
</style>
